import { put } from 'redux-saga/effects';

import { IResponseError } from 'ApiPackage/MainModule/interfaces/IResponseError';

import { coreSetLoading } from '../actions/coreActions';

interface ISagaWrapper {
  funcTry: () => Generator;
  funcCatch?: (err: IResponseError) => Generator;
  funcFinally?: () => Generator;
}

export function* sagaWrapper({ funcTry, funcCatch, funcFinally }: ISagaWrapper) {
  try {
    yield put(coreSetLoading(true));
    yield funcTry();
  } catch (err) {
    yield funcCatch?.(err as IResponseError);
  } finally {
    yield put(coreSetLoading(false));
    yield funcFinally?.();
  }
}
